module.exports = __webpack_public_path__ + "tooltip_close.03de1f1c705b7c21292c763921b47431.png";